const experienceData = [
  {
    company: "Fannie Mae",
    role: "Senior Full Stack Developer",
    desc: "Built enterprise reporting systems using AWS, Lambda, and Python."
  },
  {
    company: "Capital One",
    role: "Python Developer",
    desc: "Worked on large-scale economic data and forecasting systems."
  },
  {
    company: "CoreCommodity",
    role: "Full Stack Developer",
    desc: "Developed trading platforms with Django, Flask, and AWS."
  }
];

export default function Experience() {
  return (
    <section className="py-20 px-6 max-w-5xl mx-auto">
      <h2 className="text-3xl font-semibold text-center mb-10">Experience</h2>

      <div className="space-y-6">
        {experienceData.map((job, i) => (
          <div
            key={i}
            className="bg-gray-900 border border-gray-800 rounded-2xl p-6"
          >
            <h3 className="text-xl font-bold">{job.company}</h3>
            <p className="text-sm text-gray-500">{job.role}</p>
            <p className="text-gray-400 mt-2">{job.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}